// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-calendar {
  width: 100% !important;
  border: none !important;
  background-color: transparent !important;
  z-index: 100 !important;
}

.react-calendar__tile--now {
  background-color: transparent !important;
  color: #414141 !important;
}

.react-calendar__tile--now abbr {
  border: 1px solid #1e42a6 !important;
  border-radius: 100%;
  background-color: #1e42a6 !important;
  color: white;
}

.react-calendar__tile--active {
  padding: 1px 0px 23px !important;
  background-color: transparent !important;
  color: inherit !important;
}

.react-calendar__tile--active abbr {
  border-radius: 100%;
  background-color: #e7efff;
}

.react-calendar__month-view abbr {
  font-size: 14px;
  font-weight: 500;
  min-width: 26px;
  min-height: 26px;
  text-align: center;
  line-height: 26px;
}

.react-calendar__navigation {
  height: 24px !important;
  margin-bottom: 24px !important;
}

/* .react-calendar__navigation button:focus {
  background-color: white;
} */

.react-calendar__month-view__weekdays abbr {
  text-decoration: none;
  font-weight: normal;
  opacity: 70%;
}

.react-calendar__month-view__weekdays__weekday--weekend abbr[title='일요일'] {
  color: #f5222d;
}

.react-calendar__tile.react-calendar__month-view__days__day {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1px 0px 23px !important;
}

.react-calendar__tile {
  position: relative;
  height: 56px !important;
}

.react-calendar__tile:disabled {
  position: relative;
  opacity: 50%;
  background-color: transparent !important;
}

.react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {
  font-size: 20px;
  font-weight: 600;
}

.react-calendar__navigation {
  display: flex;
  justify-content: left;
}

.react-calendar__navigation__label {
  font-size: 20px;
  color: #414141;
  flex-grow: initial !important;
}

.react-calendar__navigation__arrow.react-calendar__navigation__prev-button,
.react-calendar__navigation__arrow.react-calendar__navigation__next-button {
  font-size: 35px;
  font-weight: 200;
  margin-bottom: 3px;
  background-color: transparent !important;
}

.react-calendar__navigation button:enabled,
.react-calendar__navigation button:enabled:hover {
  background-color: transparent !important;
}

.react-calendar__tile--active:enabled:hover {
  background: transparent !important;
}

.react-calendar__navigation button:disabled {
  background-color: white;
  color: #bebebe;
  background-color: transparent !important;
}

.sunday {
  color: #f5222d !important;
}

.exceptSunday {
  color: #414141 !important;
}

.opacity {
  opacity: 50% !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/customCalendarStyle.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;;GAEG;;AAEH;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".react-calendar {\n  width: 100% !important;\n  border: none !important;\n  background-color: transparent !important;\n  z-index: 100 !important;\n}\n\n.react-calendar__tile--now {\n  background-color: transparent !important;\n  color: #414141 !important;\n}\n\n.react-calendar__tile--now abbr {\n  border: 1px solid #1e42a6 !important;\n  border-radius: 100%;\n  background-color: #1e42a6 !important;\n  color: white;\n}\n\n.react-calendar__tile--active {\n  padding: 1px 0px 23px !important;\n  background-color: transparent !important;\n  color: inherit !important;\n}\n\n.react-calendar__tile--active abbr {\n  border-radius: 100%;\n  background-color: #e7efff;\n}\n\n.react-calendar__month-view abbr {\n  font-size: 14px;\n  font-weight: 500;\n  min-width: 26px;\n  min-height: 26px;\n  text-align: center;\n  line-height: 26px;\n}\n\n.react-calendar__navigation {\n  height: 24px !important;\n  margin-bottom: 24px !important;\n}\n\n/* .react-calendar__navigation button:focus {\n  background-color: white;\n} */\n\n.react-calendar__month-view__weekdays abbr {\n  text-decoration: none;\n  font-weight: normal;\n  opacity: 70%;\n}\n\n.react-calendar__month-view__weekdays__weekday--weekend abbr[title='일요일'] {\n  color: #f5222d;\n}\n\n.react-calendar__tile.react-calendar__month-view__days__day {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1px 0px 23px !important;\n}\n\n.react-calendar__tile {\n  position: relative;\n  height: 56px !important;\n}\n\n.react-calendar__tile:disabled {\n  position: relative;\n  opacity: 50%;\n  background-color: transparent !important;\n}\n\n.react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.react-calendar__navigation {\n  display: flex;\n  justify-content: left;\n}\n\n.react-calendar__navigation__label {\n  font-size: 20px;\n  color: #414141;\n  flex-grow: initial !important;\n}\n\n.react-calendar__navigation__arrow.react-calendar__navigation__prev-button,\n.react-calendar__navigation__arrow.react-calendar__navigation__next-button {\n  font-size: 35px;\n  font-weight: 200;\n  margin-bottom: 3px;\n  background-color: transparent !important;\n}\n\n.react-calendar__navigation button:enabled,\n.react-calendar__navigation button:enabled:hover {\n  background-color: transparent !important;\n}\n\n.react-calendar__tile--active:enabled:hover {\n  background: transparent !important;\n}\n\n.react-calendar__navigation button:disabled {\n  background-color: white;\n  color: #bebebe;\n  background-color: transparent !important;\n}\n\n.sunday {\n  color: #f5222d !important;\n}\n\n.exceptSunday {\n  color: #414141 !important;\n}\n\n.opacity {\n  opacity: 50% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
